import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { ICountry } from "../../models";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class CountryListService {
  constructor(private http: HttpClient) {}

  // function 'get's a list of International Countries from the API
  getCountryList = (): Observable<ICountry[]> => {
    return (
      this.http
        .get(`${environment.apiUrl}/getProvincesStates`)
        // Getting the array of countries from the CountriesList Container
        .pipe(map((response) => response["countriesList"])) as Observable<
        ICountry[]
      >
    );
  };
}
